export default __webpack_public_path__ + "static/media/fluxo.0d6eee9d.png";